import React, { useEffect, useState } from "react";
import { Space, Layout, Form, Input, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { adminLogin } from "../../redux/actions/adminAuthAction";
import { useThemedLogo } from "../../theme/useThemedLogo";

export default function AdminLogin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logo = useThemedLogo();
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("adminAccessToken")) {
      navigate("/admin");
    }
  });

  const onSubmit = (values) => {
    setLoading(true);
    dispatch(adminLogin(values))
      .then(() => {
        setTimeout(() => {
          navigate("/admin");
          setLoading(false);
          window.location.reload();
        }, 500);
      })
      .catch(() => {
        setTimeout(() => setLoading(false), 1000);
      });
  };

  return (
    <Layout>
      <Space
        direction="vertical"
        align="center"
        style={{
          display: "flex",
          minHeight: "100vh",
          justifyContent: "center",
          padding: "2rem 1.5rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "end",
            gap: 15,
            maxWidth: "100%",
          }}
        >
          <img
            src={logo}
            alt="Mailinflow Logo"
            height={60}
            style={{ maxWidth: "100%", height: "auto", maxHeight: 60 }}
          />
        </div>
        <Form
          onFinish={onSubmit}
          layout="vertical"
          style={{ marginTop: "3rem", width: "min(400px, calc(100vw - 3rem))" }}
        >
          <Form.Item
            name="emailAddress"
            rules={[
              { required: true, message: "Please input your email address!" },
              { type: "email", message: "Please enter a valid email address" },
            ]}
          >
            <Input placeholder="Email Address" />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Please input your password!" },
            ]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" loading={isLoading} block>
              Login
            </Button>
          </Form.Item>
        </Form>
      </Space>
    </Layout>
  );
}
